// import React from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';

// const Footer = () => {
//   const quickLinks = [
//     { name: 'Home', path: '/' },
//     { name: 'About Us', path: '/about' },
//     { name: 'Our Services', path: '/services' },
//     { name: 'Portfolio', path: '/portfolio' },
//     { name: 'Contact Us', path: '/contact' },
//   ];

//   const services = [
//     { name: 'Meta Virtual Assistant', path: '/services/meta-virtual-assistant' },
//     { name: 'Growth & Visibility (SEO)', path: '/services/growth-visibility' },
//     { name: 'Marketing & Client Acquisition', path: '/services/marketing-client-acquisition' },
//     { name: 'Digital Platforms & Experience', path: '/services/digital-platforms-experience' },
//     { name: 'Creative, Media & Branding', path: '/services/creative-media-branding' },
//     { name: 'Systems & Automation', path: '/services/systems-automation-consulting' },
//   ];

//   const socialLinks = [
//     {
//       name: 'Facebook',
//       url: '#',
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
//         </svg>
//       )
//     },
//     {
//       name: 'Instagram',
//       url: '#',
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//         </svg>
//       )
//     },
//     {
//       name: 'LinkedIn',
//       url: '#',
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
//         </svg>
//       )
//     },
//     {
//       name: 'Twitter',
//       url: '#',
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
//         </svg>
//       )
//     }
//   ];

//   return (
//     <footer className="bg-white border-t border-gray-200">
//       {/* Main Footer Content */}
//       <div className="max-w-7xl mx-auto px-6 py-16">
//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          
//           {/* Brand Column */}
//           <div>
//             <Link to="/" className="flex items-center gap-3 mb-6">
//               <img 
//                 src="/images/logo.png" 
//                 alt="Metacova Logo"
//                 className="h-12 w-auto"
//               />
//               <span className="text-2xl font-bold text-gray-900">
//                 Metacova
//               </span>
//             </Link>
//             <p className="text-gray-600 text-sm leading-relaxed mb-6">
//               Metacova is an innovative online marketing agency offering a myriad of integrated web marketing services to business across the world.
//             </p>
            
//             {/* Partner Badges */}
//             <div className="flex items-center gap-3 flex-wrap">
//               <img 
//                 src="/images/google-partner.png" 
//                 alt="Google Partner"
//                 className="h-10 w-auto object-contain"
//               />
//               <img 
//                 src="/images/facebook-partner.png" 
//                 alt="Facebook Marketing Partner"
//                 className="h-10 w-auto object-contain"
//               />
//             </div>
//           </div>

//           {/* Important Links */}
//           <div>
//             <h4 className="text-lg font-bold text-gray-900 mb-6">
//               Important Links
//             </h4>
//             <ul className="space-y-3">
//               {quickLinks.map((link) => (
//                 <li key={link.name}>
//                   <Link 
//                     to={link.path}
//                     className="text-gray-600 text-sm hover:text-[#E85A2C] transition-colors"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Our Services */}
//           <div>
//             <h4 className="text-lg font-bold text-gray-900 mb-6">
//               Our Services
//             </h4>
//             <ul className="space-y-3">
//               {services.map((service) => (
//                 <li key={service.name}>
//                   <Link 
//                     to={service.path}
//                     className="text-gray-600 text-sm hover:text-[#E85A2C] transition-colors"
//                   >
//                     {service.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Reach Us */}
//           <div>
//             <h4 className="text-lg font-bold text-gray-900 mb-6">
//               Reach Us
//             </h4>
//             <div className="space-y-4">
//               {/* Address */}
//               <div className="flex items-start gap-3">
//                 <div className="w-5 h-5 mt-0.5 flex-shrink-0">
//                   <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
//                   </svg>
//                 </div>
//                 <p className="text-gray-600 text-sm">
//                   1317 Edgewater Dr, Suite 897, Orlando, Florida 32804, US
//                 </p>
//               </div>
              
//               {/* Phone 1 */}
//               <a 
//                 href="tel:+14072040600" 
//                 className="flex items-center gap-3 group"
//               >
//                 <div className="w-5 h-5 flex-shrink-0">
//                   <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                   </svg>
//                 </div>
//                 <span className="text-gray-600 text-sm group-hover:text-[#E85A2C] transition-colors">
//                   +1 (407) 204-0600
//                 </span>
//               </a>

//               {/* Phone 2 */}
//               {/* <a 
//                 href="tel:+971547064859" 
//                 className="flex items-center gap-3 group"
//               >
//                 <div className="w-5 h-5 flex-shrink-0">
//                   <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                   </svg>
//                 </div>
//                 <span className="text-gray-600 text-sm group-hover:text-[#E85A2C] transition-colors">
//                   +971 54 706 4859
//                 </span>
//               </a>

//               {/* Phone 3 */}
//               {/* <a 
//                 href="tel:+919818456688" 
//                 className="flex items-center gap-3 group"
//               >
//                 <div className="w-5 h-5 flex-shrink-0">
//                   <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                   </svg>
//                 </div>
//                 <span className="text-gray-600 text-sm group-hover:text-[#E85A2C] transition-colors">
//                   +91 9818456688
//                 </span>
//               </a> */} 
              
//               {/* Email */}
//               <a 
//                 href="mailto:hello@metacova.com" 
//                 className="flex items-center gap-3 group"
//               >
//                 <div className="w-5 h-5 flex-shrink-0">
//                   <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
//                   </svg>
//                 </div>
//                 <span className="text-gray-600 text-sm group-hover:text-[#E85A2C] transition-colors">
//                   hello@metacova.com
//                 </span>
//               </a>

//               {/* Social Links */}
//               <div className="flex gap-3 pt-4">
//                 {socialLinks.map((social) => (
//                   <motion.a
//                     key={social.name}
//                     href={social.url}
//                     whileHover={{ scale: 1.1 }}
//                     whileTap={{ scale: 0.95 }}
//                     className="w-10 h-10 rounded-full flex items-center justify-center bg-[#E85A2C] text-white hover:bg-[#D14B1D] transition-colors"
//                     title={social.name}
//                   >
//                     {social.icon}
//                   </motion.a>
//                 ))}
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <div className="border-t border-gray-200 py-6">
//         <div className="max-w-7xl mx-auto px-6 text-center">
//           <p className="text-gray-500 text-sm">
//             © {new Date().getFullYear()} All rights reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Our Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const services = [
    { name: 'Patient Growth & Visibility', path: '/services/growth-visibility' },
    { name: 'Ads & Patient Acquisition', path: '/services/marketing-client-acquisition' },
    { name: 'Social Media & Branding', path: '/services/social-media-branding' },
    { name: 'Lead Management & Virtual Assistants', path: '/services/meta-virtual-assistant' },
    { name: 'Patient Communication & Analytics', path: '/services/patient-communication-analytics' },
    { name: 'Websites, Apps & Technology', path: '/services/digital-platforms-experience' },
    { name: 'Creative, Media & Content', path: '/services/creative-media-branding' },
    { name: 'Systems, Compliance & Consulting', path: '/services/systems-automation-consulting' },
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      url: '#',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      url: '#',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      )
    },
    {
      name: 'LinkedIn',
      url: '#',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    {
      name: 'Twitter',
      url: '#',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      )
    }
  ];

  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          
          {/* Brand Column with Map */}
          <div>
           
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Docmize is an innovative healthcare Growth Ecosystem agency offering comprehensive services to medical practices, doctors, and hospitals worldwide.
            </p>
            
            {/* Google Map */}
           <div className="w-full h-48 rounded-lg overflow-hidden border border-gray-200 mb-4">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.956789!2d77.0147381!3d28.4897609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a8ed6c3d8fdbcbf%3A0xe3e39996315bc6d2!2sDocmize%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1738483200000!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Docmize Office Location"
  ></iframe>
</div>
          </div>

          {/* Important Links */}
          <div>
            <h4 className="text-lg font-bold text-[#19354a] mb-6">
              Important Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-600 text-sm hover:text-[#39a5d3] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg font-bold text-[#19354a] mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.path}
                    className="text-gray-600 text-sm hover:text-[#39a5d3] transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Reach Us */}
          <div>
            <h4 className="text-lg font-bold text-[#19354a] mb-6">
              Reach Us
            </h4>
            <div className="space-y-4">
              {/* Address */}
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 mt-0.5 flex-shrink-0">
                  <svg className="w-5 h-5 text-[#39a5d3]" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <p className="text-gray-600 text-sm">
                  Swastik Appartment, Block H Rd, Block H, Ashok Vihar, Ashok Vihar Phase II, Gurugram, Haryana 122015
                </p>
              </div>
              
              {/* Phone */}
              <a 
                href="tel:+918920845297" 
                className="flex items-center gap-3 group"
              >
                <div className="w-5 h-5 flex-shrink-0">
                  <svg className="w-5 h-5 text-[#39a5d3]" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </div>
                <span className="text-gray-600 text-sm group-hover:text-[#39a5d3] transition-colors">
                  +91 8920845297
                </span>
              </a>
              
              {/* Email */}
              <a 
                href="mailto:mail@docmize.com" 
                className="flex items-center gap-3 group"
              >
                <div className="w-5 h-5 flex-shrink-0">
                  <svg className="w-5 h-5 text-[#39a5d3]" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <span className="text-gray-600 text-sm group-hover:text-[#39a5d3] transition-colors">
                  mail@docmize.com
                </span>
              </a>

              {/* Social Links */}
              <div className="flex gap-3 pt-4">
                {socialLinks.map((social) => (
                  <motion.a
                    key={social.name}
                    href={social.url}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-10 h-10 rounded-full flex items-center justify-center bg-[#19354a] text-white hover:bg-[#39a5d3] transition-colors"
                    title={social.name}
                  >
                    {social.icon}
                  </motion.a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Docmize. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;  